export const LOGGING_START = 'LOGGING_START';
export const LOGGING_SUCCESS = 'LOGGING_SUCCESS';

export const LOGGING_POST_INFO = 'LOGGING_POST_INFO';
export const LOGGING_POST_INFO_SUCCESS = 'LOGGING_POST_INFO_SUCCESS';
